import { render } from "./postage_import.vue?vue&type=template&id=4ac55223&scoped=true"
import script from "./postage_import.vue?vue&type=script&lang=js"
export * from "./postage_import.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac55223"]])

export default __exports__